import { useAppSelector } from '@reducers/index';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { APP_INSTALL } from '../const/localStorageKeys';
function useOnlyNewUsers(date) {
    const { value: appInitDate } = useAppSelector(state => ({ value: state.flags[APP_INSTALL] }));
    const initMoment = useMemo(() => {
        if (!appInitDate)
            return null;
        return dayjs(appInitDate);
    }, [appInitDate]);
    const isNewUser = useMemo(() => {
        if (!initMoment)
            return false;
        const dateMoment = dayjs(date);
        return dateMoment.isBefore(initMoment);
    }, [initMoment, date]);
    return isNewUser;
}
export default useOnlyNewUsers;
